import { faCheck, faMobile } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import styled from "styled-components"
import { ColorUtils } from "../utils/ColorUtils"

export enum TagsSize {
  SMALL,
  MEDIUM,
}

// background: ${(props) =>
// ColorUtils.decodeGradient(props.color, "to right")};
// color: ${(props) => ColorUtils.textColorFor(props.color)};
const TagsStyled = styled.div`
  // padding: 6px 12px;
  // background: ${(props) => props.color};
  // color: #ffffffee;
  // border-radius: 50px;
  // margin: 0 2px;
  // display: inline-block;
  // font-weight: 800;
  // font-size: 10px;
  // // font-weight: normal;
  // //   display: flex;
  // flex-direction: row;
  // align-items: center;
  // // padding-left: 28px;
  // position: relative;

  // > .icon {
  //   margin: 0 4px;
  //   width: 20px;
  //   position: absolute;
  //   left: 4px;
  // }
  // opacity: 0.95;
  // transition: opacity 150ms ease-in-out;
  // &:hover {
  //   opacity: 1;
  // }
`
export type TagsProps = {
  label?: string
  color?: string
  size?: TagsSize
  className?: string
}

export const Tags = (
  { label, color, size, className }: TagsProps = { size: TagsSize.MEDIUM }
) => {
  return (
    <TagsStyled
      className={`font-normal text-sm text-black py-1 px-2 rounded-full border-borderGray border my-1 ${className}`}
    >
      {label}
    </TagsStyled>
  )
}
